import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AppConfigService} from "./config/app-config.service";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class UserService {
  tradeAuthUrl: string | undefined;
  tradeBoUrl: string | undefined;
  env: string | undefined;
  institutionId:any;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.tradeAuthUrl = appConfig.getCommonConfig?.portalAuth;
    this.tradeBoUrl = appConfig.getCommonConfig?.portalBO;
  }

  getSortedFilteredUsersDetails(userType: number, sortOrder:string, sortBy:string,  filter:string, filterText:string, pageNo: number, pageWidth: number, institutionCode:any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.sortedFilteredUsersDetailsPath, {
      userType,
      sortOrder,
      sortBy,
      filter,
      filterText,
      pageNo,
      pageWidth,
      institutionCode
    }, httpOptions);
  }

  getLoggedInUserDetails(username: string): Observable<any> {
    const params = new HttpParams().set('username', username);
    return this.http.get(this.tradeBoUrl + environment.profileDetailsPath, {params});
  }

  getCountryList(): Observable<any> {
    return this.http.get(this.tradeBoUrl + environment.countryListPath);
  }

  editProfileDetails(
    firstName: string,
    lastName: string,
    email: string,
    contactNo: string,
    profession: any,
    companyName: string,
    countryId: string,
    username: string,
    institutionId: string,
    adminUser: string,
    region: string,openAPIEnabled: any,
    embedAPIEnabled: any,
    backOfficeAPIEnabled: any,
    dwmAPIEnabled: any,feedAPIEnabled: any): Observable<any> {
    return this.http.patch(this.tradeBoUrl + environment.profileEditPath, {
      firstName,
      lastName,
      contactNo,
      email,
      companyName,
      profession,
      countryId,
      username,
      institutionId,
      adminUser,
      region,
      openAPIEnabled,
      embedAPIEnabled,
      backOfficeAPIEnabled,
      dwmAPIEnabled,
      feedAPIEnabled
    }, httpOptions);
  }

  editNormalBrokerProfileDetails(
    firstName: string,
    lastName: string,
    email: string,
    contactNo: string,
    profession: any,
    companyName: string,
    countryId: string,
    username: string,
    institutionCode: string,
    adminUser: string,
    region: string): Observable<any> {
    return this.http.patch(this.tradeBoUrl + environment.normalBrokerProfileEditPath, {
      firstName,
      lastName,
      contactNo,
      email,
      companyName,
      profession,
      countryId,
      username,
      institutionCode,
      adminUser,
      region
    }, httpOptions);
  }

  createBroker(firstName: any, lastName: any, companyName: any, profession: any,
               contactNo: any, countryId: any, email: any, username: any, institutionId: any, password: any, adminUser: any, region:any, role:any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.brokerCreatePath, {
      firstName,
      lastName,
      username,
      institutionId,
      companyName,
      profession,
      contactNo,
      countryId,
      email,
      password,
      adminUser,
      region,
      role
    }, httpOptions)
  }
  createNormalBroker(firstName: any, lastName: any, companyName: any, profession: any,
               contactNo: any, countryId: any, email: any, username: any, institution: any, password: any, adminUser: any, region:any): Observable<any> {


    return this.http.post(this.tradeBoUrl + environment.normalBrokerCreatePath, {
      firstName,
      lastName,
      username,
      institution,
      companyName,
      profession,
      contactNo,
      countryId,
      email,
      password,
      adminUser,
      region
    }, httpOptions)
  }
  getInstitutionList(): Observable<any> {
    return this.http.get(this.tradeBoUrl + environment.institutionListPath);
  }

  validateUserName(username: string): Observable<any> {
    const params = new HttpParams().set('username', username);
    return this.http.get(this.tradeBoUrl + environment.validateUserNamePath, {params});
  }

  getSortedFilteredPendingUsersDetails(role:any,sortOrder:string, sortBy:string,  filter:string, filterText:string, pageNo: number, pageWidth: number): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.sortedFilteredPendingUsersDetailsPath, {
      role,
      sortOrder,
      sortBy,
      filter,
      filterText,
      pageNo,
      pageWidth
    }, httpOptions);
  }

  rejectPendingBrokerUser(id: number): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.delete(this.tradeBoUrl + environment.rejectBrokerRequestPath, {params});
  }

  deleteBrokerUser(id: number): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.delete(this.tradeBoUrl + environment.deleteBrokerPath, {params});
  }

  approveBrokerUser(role:any,id: number, adminUser: string, institutionId: number, region:string, openAPIEnabled: any,
                    embedAPIEnabled: any,
                    backOfficeAPIEnabled: any,
                    dwmAPIEnabled: any,feedAPIEnabled: any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.approveBrokerPath, {
      role,
      id,
      adminUser,
      institutionId,
      region,
      openAPIEnabled,
      embedAPIEnabled,
      backOfficeAPIEnabled,
      dwmAPIEnabled,
      feedAPIEnabled
    }, httpOptions);
  }

  changeBrokerPassword(username: string, currentPassword: string, newPassword: string, isInitialLogin: boolean): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.changeBrokerPasswordPath, {
      username,
      currentPassword,
      newPassword,
      isInitialLogin
    }, httpOptions);
  }

  resetPassword(email: string): Observable<any> {
    const params = new HttpParams().set('email', email);
    return this.http.get(this.tradeBoUrl + environment.resetPasswordPath, {params});
  }

  registerBroker(firstName: any, lastName: any, companyName: any, profession: any,
                 contactNo: any, countryId: any, email: any, username: any, region: any, role:any,openAPIEnabled: any,
                 embedAPIEnabled: any,
                 backOfficeAPIEnabled: any,
                 dwmAPIEnabled: any,feedAPIEnabled: any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.brokerRequestPath, {
      firstName,
      lastName,
      companyName,
      profession,
      contactNo,
      countryId,
      email,
      username,
      region,
      role,
      openAPIEnabled,
      embedAPIEnabled,
      backOfficeAPIEnabled,
      dwmAPIEnabled,
      feedAPIEnabled
    }, httpOptions)
  }

  getInstitutionalApiListByInstitutionId(institutionId:any) :Observable<any> {
    const params = new HttpParams().set('institutionId', institutionId);
    return this.http.get(this.tradeBoUrl + environment.institutionalApiListByInstitutionIdPath, {params});
  }

  getInstitutionalApiListByInstitutionId2(institutionId:any, region:any) :Observable<any> {
    const params = new HttpParams().set('institutionId', institutionId);
    return this.http.get(this.tradeBoUrl + environment.institutionalApiListByInstitutionIdPath, {params});
  }

  getInstitutionalApiListByInstitutionCode(institutionCode:any) :Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);
    return this.http.get(this.tradeBoUrl + environment.institutionalApiListByInstitutionCodePath, {params});
  }

  getInstitutionListPagination(
    pageNo: number,
    pageWidth: number,
    sortOrder:string,
    sortBy:string,
    filter:string,
    filterText:string
  ): Observable<any> {
    const params = new HttpParams()
      .set('pageNo', pageNo)
      .set('pageWidth', pageWidth)
      .set('sortOrder', sortOrder)
      .set('sortBy', sortBy)
      .set('filter', filter)
      .set('filterText', filterText)
    ;
    return this.http.get(
      this.tradeBoUrl + environment.institutionListPaginationPath,
      { params }
    );
  }

  getCustomerDetails(customerNumber: string, region:any): Observable<any> {
    const params = new HttpParams().set('customerNumber', customerNumber);

    return this.http.get(this.tradeBoUrl + environment.customerDetails, {
      params,
    });
  }

  getCustomerAccountDetails(customerId: any, region:any): Observable<any> {
    const params = new HttpParams().set('customerId', customerId);

    return this.http.get(this.tradeBoUrl + environment.customerDetailsByCustomerId, {
      params,
    });
  }

  getInstExchangesList(institutionCode: string, region:any): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);

    return this.http.get(this.tradeBoUrl + environment.instExchangesListPath, {
      params,
    });
  }

  getBankAccountDetails(institutionCode: string, bankID : string, region:any): Observable<any> {
    const params = new HttpParams()
      .set('institutionCode', institutionCode)
      .set('bankId', bankID);
    return this.http.get(this.tradeBoUrl + environment.bankAccountDetailsPath, {
      params,
    });
  }
  getInstBankList(institutionCode: string, region:any): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);

    return this.http.get(this.tradeBoUrl + environment.instBankListPath, {
      params,
    });
  }

  getInstCustomerProfile(institutionCode: string, region:any): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);
    return this.http.get(this.tradeBoUrl + environment.instCustomerProfilePath, {
      params,
    });
  }

  getInstSubscriptionPackageList(institutionCode: string, region:any): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);

    return this.http.get(
      this.tradeBoUrl + environment.instSubscriptionPackageListPath,
      { params }
    );
  }

  getInstitutionDetails(institutionCode: string): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);
    return this.http.get(
      this.tradeBoUrl + environment.institutionDetailsPath,
      { params }
    );
  }

  saveAppCredentials(institutionCode: string, appKey: string, appSecret: string): Observable<any> {

    return this.http.post(this.tradeBoUrl + environment.saveAppCredentialsPath, {
      institutionCode,
     appKey,
      appSecret
    }, httpOptions);
  }
  getCurrencyList(): Observable<any> {

    return this.http.get(this.tradeBoUrl + environment.currencyListPath);
  }
  addTradeLimit(institutionCode: any, currency: any, odLimit: any,marginLimit: any,dayTradingLimit: any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.addTradeLimitPath, {
      institutionCode,
      currency,
      odLimit,
      marginLimit,
      dayTradingLimit
    }, httpOptions)
  }
  addMasterTradeLimit(institutionCode: any, currency: any, masterLimit:any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.addMasterTradeLimitPath, {
      institutionCode,
      currency,
      masterLimit
    }, httpOptions)
  }
  getCountryCode(ipAddress: any) {
    return this.http.get(`https://ipapi.co/${ipAddress.ip}/json/`, {
      responseType: 'text',
    });
  }
  getIp() {
    return  this.http.get('https://api.ipify.org/?format=json');
  }
  getInstitution(instCode: string): Observable<any> {
    const params = new HttpParams().set('institutionCode', instCode);

    return this.http.get(this.tradeBoUrl + environment.getInstitutionPath, {
      params,
    });
  }
  createSecurityAccount(cashAccountNumber: any, securityAccountType: any): Observable<any> {

    return this.http.post(this.tradeBoUrl + environment.createSecurityAccountPath, {
      cashAccountNumber,
      securityAccountType
    }, httpOptions)
  }
  createExchangeAccount(accountNumber: any, exchange: any, executingBrokerId:any, isMasterAcc:any): Observable<any> {
    const params = new HttpParams().set('isMasterAcc', isMasterAcc);
    const body = { accountNumber: accountNumber, exchange: exchange ,executingBrokerId:executingBrokerId};
    return this.http.post(this.tradeBoUrl + environment.createExchangeAccountPath,
      body,
      { params })
  }
  exchangeAccTradinEnable(exchangeAccountId: any, status: any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.exchangeAccountTradingEnablePath, {
      exchangeAccountId,
      status
    }, httpOptions)
  }
  createCashAccount(customerNumber: string, currency: string): Observable<any> {

    return this.http.post(this.tradeBoUrl + environment.createCashAccountPath, {
      customerNumber,
      currency
    }, httpOptions)
  }
  getExecutingBrokerList(exchangeCode: string): Observable<any> {
    const params = new HttpParams().set('exchangeCode', exchangeCode);
    return this.http.get(this.tradeBoUrl + environment.executingBrokerListPath, {
      params,
    });
  }
  defaultSubscriptionPackage(id: any,instCode:any):Observable<any>{
    const params = new HttpParams().set('packageId', id).set('institutionCode', instCode);
    return this.http.get(this.tradeBoUrl + environment.defaultSubscriptionPackPath, {
      params
    })
  }
  defaultProfile(id: any,instCode:any):Observable<any>{
    const params = new HttpParams().set('profileId', id).set('institutionCode', instCode);
    return this.http.get(this.tradeBoUrl + environment.defaultProfilePath, {
      params
    })
  }
  customerProfileCreation(profileName:any,description:any,institutionCode:any,createdBy:any,isDefault:any){
    return this.http.post(this.tradeBoUrl+environment.customerProfileCreation,{profileName,description,institutionCode,createdBy,isDefault

    },httpOptions)
  }
  getInstSubscriptionPackageById(id: string): Observable<any> {
    const params = new HttpParams().set('packageId', id);
    return this.http.get(
      this.tradeBoUrl + environment.instSubscriptionPackageByIdPath,
      { params }
    );
  }
  getDefaultValuesOfExchange(exchangeCode:any):Observable<any>{
    const params = new HttpParams().set('exchangeCode', exchangeCode);
    return this.http.get(this.tradeBoUrl + environment.defaultValuesOfExchange, {
      params
    })
  }
  updateSubscriptionPackage(packageId:any,institutionCode:any,createdBy:any,exchangeList:any){
    return this.http.patch(this.tradeBoUrl+environment.updateSubscriptionPackage,{packageId,institutionCode,createdBy, exchangeList
    },httpOptions)
  }
  updateSubscriptionPackageDetails(packageId:any,institutionCode:any,createdBy:any,packageName:any,packageDescription:any){
    return this.http.patch(this.tradeBoUrl+environment.updateSubscriptionPackage,{packageId,institutionCode,createdBy, packageName,packageDescription
    },httpOptions)
  }
  addSubscriptionPackage(packageName:any,packageDescription:any,institutionCode:any,createdBy:any,isDefault:any){
    return this.http.post(this.tradeBoUrl+environment.addSubscriptionPackage,{packageName,packageDescription,institutionCode,createdBy,isDefault
    },httpOptions)
  }
  createMasterAccount(institutionCode: any, lastName: string, mobile: string, email: string, profession: string, countryId: number, nationality: string, createdBy: number): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.createMasterAccountPath, {


      institutionCode,
      lastName,
      mobile,
      email,
      profession,
      countryId,
      nationality,
      createdBy
    }, httpOptions)
  }
  validateInstCode(instCode: string): Observable<any> {
    const params = new HttpParams().set('institutionCode', instCode);
    return this.http.get(this.tradeBoUrl + environment.validateInstCodePath, {
      params,
    });
  }
  createInstitution(
    institutionCode:any,
    institutionName: any,
    address: any,
    email: any,
    telephoneNo: any,
    managerName: any,
    institutionStatus: any,
    activationPeriod: any,
    suspensionPeriod: any,
    deletionPeriod: any,
    openApiEnabled: any,
    fixEnabled: any,
    boApisEnabled: any,
    dwmApiEnabled: any,
    depositAutoApproval: any,
    withdrawAutoApproval: any,
    buyingPower : any,
    publicKey: any,
    appKey: any,
    appSecret: any): Observable<any> {
    return this.http.post(
      this.tradeBoUrl + environment.addInstitutionPath,
      {
        institutionCode,
        institutionName,
        address,
        email,
        telephoneNo,
        managerName,
        institutionStatus,
        activationPeriod,
        suspensionPeriod,
        deletionPeriod,
        openApiEnabled,
        fixEnabled,
        boApisEnabled,
        dwmApiEnabled,
        depositAutoApproval,
        withdrawAutoApproval,
        buyingPower,
        publicKey,
        appKey,
        appSecret,
      },
      httpOptions
    );
  }

  updateInstitution(
    institutionCode:any,
    institutionName: any,
    address: any,
    email: any,
    // fax: any,
    telephoneNo: any,
    managerName: any,
    institutionStatus: any,
    activationPeriod: any,
    suspensionPeriod: any,
    deletionPeriod: any,
    openApiEnabled: any,
    fixEnabled: any,
    boApisEnabled: any,
    depositAutoApproval: any,
    withdrawAutoApproval: any,
    buyingPower : any,
    publicKey: any,
    appKey: any,
    appSecret: any): Observable<any> {
    return this.http.patch(
      this.tradeBoUrl + environment.addInstitutionPath,
      {
        institutionCode,
        institutionName,
        address,
        email,
        // fax,
        telephoneNo,
        managerName,
        institutionStatus,
        activationPeriod,
        suspensionPeriod,
        deletionPeriod,
        openApiEnabled,
        fixEnabled,
        boApisEnabled,
        depositAutoApproval,
        withdrawAutoApproval,
        buyingPower,
        publicKey,
        appKey,
        appSecret,
      },
      httpOptions
    );
  }
  getUnassignedExchangeList(institutionCode: string): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);
    return this.http.get(this.tradeBoUrl + environment.unassignedExchangesPath, {
      params,
    });
  }
  instAssignExchange(institutionCode: any, exchangeList: any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.instAssignExchangesPath, {
      institutionCode,
      exchangeList
    }, httpOptions)
  }
  createInstBankAcc(bankAccountNumber: any, bankId: any, institutionCode: any, currency: any, odLimit: any, createdBy: any,
                    branch: any, contactName: any, contactNo: any, isDefault: any): Observable<any> {
    return this.http.post(this.tradeBoUrl + environment.addInstBankAccPath, {
      bankAccountNumber,
      bankId,
      institutionCode,
      currency,
      odLimit,
      createdBy,
      branch,
      contactName,
      contactNo,
      isDefault

    }, httpOptions)
  }

  updateInstBankAcc(bankAccountId:any, bankAccountNumber: any, bankId: any, institutionCode: any, currency: any, odLimit: any, createdBy: any,
                    branch: any, contactName: any, contactNo: any, isDefault: any): Observable<any> {
    return this.http.patch(this.tradeBoUrl + environment.addInstBankAccPath, {
      bankAccountId,
      bankAccountNumber,
      bankId,
      institutionCode,
      currency,
      odLimit,
      createdBy,
      branch,
      contactName,
      contactNo,
      isDefault

    }, httpOptions)
  }
  getUnassignedInstBankList(institutionCode: string): Observable<any> {
    const params = new HttpParams().set('institutionCode', institutionCode);
    return this.http.get(this.tradeBoUrl + environment.unassignedInstBanksPath, {
      params,
    });
  }
  assignInstBanks(bankIds: any, institutionCode: string) : Observable<any>{
    return this.http.post(this.tradeBoUrl + environment.instBankAssignPath, {
      bankIds,
      institutionCode
    }, httpOptions)
  }

  getAdminDashboardData(section: string,  version:string, timeFilter:string): Observable<any> {
    const params = new HttpParams().set('section', section).set('version', version).set('timeFilter', timeFilter);
    return this.http.get(this.tradeBoUrl + environment.getAdminDashboardData, {
      params,
    });
  }


  validateCaptchaToken(token: string): Observable<any> {
    return this.http.post(
      this.tradeBoUrl + environment.validateCaptchaToken,
      { captchaToken: token }
    );
  }

  private getAuthBaseUrl(env: string, region: string): string {
    const baseUrls: any = {
      dev: environment.devBaseUrl + "/auth",
      qa: environment.qABaseUrl + "/auth",
      sandbox: environment.sandboxBaseUrl + "/auth",
      uat: {
        asia: environment.asiaUATBaseUrl + "/trade/auth",
        mena: environment.menaUATBaseUrl + "/trade/auth",
        europe: environment.europeUATBaseUrl + "/trade/auth",
        us: environment.usUATBaseUrl + "/trade/auth",
        hk: environment.hkUATBaseUrl + "/auth",
      },
      production: {
        asia: environment.asiaProdBaseUrl + "/trade/auth",
        mena: environment.menaProdBaseUrl + "/trade/auth",
        europe: environment.europeProdBaseUrl + "/trade/auth",
        us: environment.usProdBaseUrl + "/trade/auth",
        hk: environment.hkProdBaseUrl + "/auth",
      }
    };
    const base = baseUrls[env];
    if (typeof base === 'string') {
      // Non-region environments (dev, qa, sandbox)
      return base;
    } else if (typeof base === 'object') {
      // Region-specific environments (uat, production)
      return base[region] || '';
    }
    return '';
  }

  generatePreSignedUrl(institutionCode: string, env: string, region: string, appName: string, narration: string, override: boolean): Observable<any> {
    const baseUrl = this.getAuthBaseUrl(env, region);
    const url = baseUrl + environment.generatePreSignedUrl;

    return this.http.post(url, {
      institutionCode,
      env,
      region,
      appName,
      narration,
      override
    }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  getInstitutionConfig(env: string, region: string, institutionCode: string): Observable<any> {
    const baseUrl = this.getAuthBaseUrl(env, region);
    const url = baseUrl + environment.institutionConfigs;

    const params = new HttpParams().set('institutionCode', institutionCode);
    return this.http.get(url, {params, headers: new HttpHeaders({ 'Content-Type': 'application/json' })});
  }

  private getBaseUrl(env: string, region: string): string {
    const baseUrls: any = {
      dev: environment.devBaseUrl,
      qa: environment.qABaseUrl,
      sandbox: environment.sandboxBaseUrl,
      uat: {
        asia: environment.asiaUATBaseUrl,
        mena: environment.menaUATBaseUrl,
        europe: environment.europeUATBaseUrl,
        us: environment.usUATBaseUrl,
        hk: environment.hkUATBaseUrl
      },
      production: {
        asia: environment.asiaProdBaseUrl,
        mena: environment.menaProdBaseUrl,
        europe: environment.europeProdBaseUrl,
        us: environment.usProdBaseUrl,
        hk: environment.hkProdBaseUrl
      }
    };
    const base = baseUrls[env];
    if (typeof base === 'string') {
      // Non-region environments (dev, qa, sandbox)
      return base;
    } else if (typeof base === 'object') {
      // Region-specific environments (uat, production)
      return base[region] || '';
    }
    return '';
  }

  generateS3UploadUrl(bucketPath: string, fileName: string, project: string, version: string): Observable<any> {
    // Use the portalBO base URL (localhost:8726) for S3 upload URL generation
    const url = this.tradeBoUrl + environment.generateS3UploadUrl;

    return this.http.post(url, {
      bucketPath,
      fileName,
      contentType: 'application/zip',
      project,
      version
    }, httpOptions);
  }

  uploadToS3(presignedUrl: string, file: File): Observable<any> {
    // Upload file directly to S3 using presigned URL
    // Note: This bypasses the auth interceptor since it's a direct S3 upload
    // Using PUT method for presigned URLs (common for S3)
    return new Observable(observer => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round((event.loaded / event.total) * 100);
          observer.next({ type: 'progress', percentComplete });
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status === 200 || xhr.status === 204) {
          observer.next({ type: 'complete' });
          observer.complete();
        } else {
          observer.error({ status: xhr.status, statusText: xhr.statusText });
        }
      });

      xhr.addEventListener('error', () => {
        observer.error({ status: xhr.status, statusText: xhr.statusText });
      });

      xhr.open('PUT', presignedUrl);
      xhr.setRequestHeader('Content-Type', 'application/zip');
      xhr.send(file);
    });
  }


}
